import AdjustUsersSettings from './AdjustUsersSettings';

export default AdjustUsersSettings;
